<template>
    <div v-if="roster">

        <h3>{{team_role}} {{ roster.name }} {{ roster.market }}</h3>

        <h4>players</h4>

        <table class="table">
            <tr>
                <th>id</th>
                <th>full_name</th>
                <th>birthdate</th>
                <th>birth_place</th>
                <th>college</th>
                <th>height</th>
                <th>jersey_number</th>
                <th>abbr_name</th>
                <th>first_name</th>
                <th>last_name</th>
                <th>position</th>
                <th>primary_position</th>
                <th>status</th>
                <th>weight</th>
                <th>experience</th>
            </tr>
            <tr v-for="player in roster.players">
                <td>{{ player.id }}</td>
                <td>{{ player.full_name }}</td>
                <td>{{ player.birthdate }}</td>
                <td>{{ player.birth_place }}</td>
                <td>{{ player.college }}</td>
                <td>{{ player.height }}</td>
                <td>{{ player.jersey_number }}</td>
                <td>{{ player.abbr_name }}</td>
                <td>{{ player.first_name }}</td>
                <td>{{ player.last_name }}</td>
                <td>{{ player.position }}</td>
                <td>{{ player.primary_position }}</td>
                <td>{{ player.status }}</td>
                <td>{{ player.weight }}</td>
                <td>{{ player.experience }}</td>
            </tr>
        </table>

        <h4>coaches</h4>

        <table class="table">
            <tr>
                <th>id</th>
                <th>name_full</th>
                <th>first_name</th>
                <th>last_name</th>
                <th>position</th>
                <th>experience</th>
            </tr>
            <tr v-for="player in roster.coaches">
                <td>{{ player.id }}</td>
                <td>{{ player.full_name }}</td>
                <td>{{ player.first_name }}</td>
                <td>{{ player.last_name }}</td>
                <td>{{ player.position }}</td>
                <td>{{ player.experience }}</td>
            </tr>
        </table>
    </div>
    
</template>

<script>
export default {
    name: 'NBARoster',
    props: {
        roster: '',
        team_role: '',
    },
    data: function() {
        return {            
            
        }
    }, 
}
</script>

